import React from 'react';
import type { AllIconType, SizeType, ThemeType } from '../../../util/types';
import type { ThemeProps } from 'styled-components';
import { Link, useRouteMatch } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { getIconComponent } from '../../../util/reactFunc';

interface Props {
  to: string,
  icon: AllIconType,
  label: string,
  size?: SizeType | number,
  disabled?: boolean;
}

const getHighlightStyles = (props: ThemeProps<ThemeType> & { $active?: boolean, $disabled?: boolean }) => {
  const activeColor = '#14BAEE'; //Todo: Is this in Theme?
  const disabledColor = '#D3D3D3';
  return css`
    color: ${props.$active ? activeColor : props.$disabled ? disabledColor : '#000'} !important;
    font-size: ${props.theme.fonts.sm};
    & svg, path {
      fill: currentColor !important;
      color: currentColor !important;
    }
    ${props.$active ? `
      font-weight: bold;
      ::after {
        content: '';
        border-bottom: 2px solid ${activeColor};
        width: 100%;
      }
    ` : ''}
    ${props.$disabled ? `
      cursor: default;
    ` : ''}
  `;
};

const NavLinkStyled = styled(Link)<{
  $active: boolean,
  $disabled?: boolean,
}>`
  ${(props) => getHighlightStyles(props)}
`;

const NavLinkDisabled = styled('span')<{
  $active: boolean,
  $disabled: boolean,
}>`
  ${(props) => getHighlightStyles(props)}
`;

const NavLink = ({ to, icon, label, size, disabled = false, ...other }: Props): JSX.Element => {
  const match = useRouteMatch({ path: to, exact: true });

  const Content = () => (
    <>
      <div className={'m-auto flex items-center md:hidden'} style={{ minHeight: 45 }}>
        {getIconComponent(icon, size)}
      </div>
      <div className={'hidden md:inline text-center'}>{label}</div>
    </>
  );
  if (disabled) {
    return (
      <NavLinkDisabled className={'flex flex-col items-center justify-between h-full'} title={label} $disabled={disabled} $active={!!match} {...other}>
        <Content />
      </NavLinkDisabled>
    );
  }
  return (
    <NavLinkStyled to={to} className={'flex flex-col items-center justify-between h-full'} title={label} $disabled={disabled} $active={!!match} {...other}>
      <Content />
    </NavLinkStyled>
  );
};

export default NavLink;
